import React, { useState, useEffect } from "react";
import { getStudentIdData } from "../../../../lib/studentbragsheet";

export default function SeniorBragSheetForProfile({ slug }) {
  const [bragSheetdb, setBragSheetDb] = useState([]);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [grade, setGrade] = useState("");
  const [deadline, setDeadline] = useState("");
  const [testScore, setTestScore] = useState("");
  const [extActivity, setExtActivity] = useState("");
  const [award, setAward] = useState("");
  const [threeAdjective, setThreeAdjective] = useState("");
  const [hobby, setHobby] = useState("");
  const [mostProud, setMostProud] = useState("");
  const [strengWeakness, setStrengWeakness] = useState("");
  const [obstacle, setObstacle] = useState("");
  const [recommendation, setRecommendation] = useState("");

  async function getDatafromMainEssay() {
    const data = await getStudentIdData(slug);
    if (data[0]) {
    setName(data[0].name);
    setEmail(data[0].email);
    setGrade(data[0].grade);
    setDeadline(data[0].deadline);
    setTestScore(data[0].testScore);
    setExtActivity(data[0].extActivity);
    setAward(data[0].award);
    setThreeAdjective(data[0].threeAdjective);
    setHobby(data[0].hobby);
    setMostProud(data[0].mostProud);
    setStrengWeakness(data[0].strengWeakness);
    setObstacle(data[0].obstacle);
    setRecommendation(data[0].recommendation);
    console.log("Additional İnfo: ", data);
    setBragSheetDb(data);
    }
  }

  useEffect(() => {
    getDatafromMainEssay();
  }, [setBragSheetDb]);

  return (
    <div className="card-body">
      <div className="row">
        <div className="col-md-12">
          <h4 className="goal_settings_title"> Senior Brag Sheet</h4>
          <h3 className="text-center">Letter of Recommendation Request</h3>
          {bragSheetdb[0] ? (
            <div>
              <table className="table table-bordered">
                <thead>
                  <tr className="bg-primary text-white">
                    <th colSpan={4}>
                      <h4 className="text-center">Contact Info</h4>
                    </th>
                  </tr>
                </thead>
                <thead>
                  <tr className="bg-primary text-white">
                    <th className="text-center">Name</th>
                    <th className="text-center">Email</th>
                    <th className="text-center">Grade</th>
                    <th className="text-center">Deadline</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="text-center">{name}</td>
                    <td className="text-center">{email}</td>
                    <td className="text-center">{grade}</td>
                    <td className="text-center">{deadline}</td>
                  </tr>
                </tbody>
              </table>

              <div className="wishlist-item mt-5">
                <div style={{ color: "black", backgroundColor: "white" }}>
                  <div className="mb-3">
                    <label className="form-label fw-bold">Test Scores:</label>
                    <div>{testScore}</div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-bold">
                      Extracurricular Activities:
                    </label>
                    <div>{extActivity}</div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-bold">Awards:</label>
                    <div>{award}</div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-bold">
                      Character Traits: Three adjectives that describe me and
                      why:
                    </label>
                    <div>{threeAdjective}</div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-bold">
                      {" "}
                      My hobbies, interests, and talents:
                    </label>
                    <div>{hobby}</div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-bold">
                      {" "}
                      What I&apos;m most proud of:
                    </label>
                    <div>{mostProud}</div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-bold">
                      {" "}
                      My strength and weaknesses:
                    </label>
                    <div>{strengWeakness}</div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-bold">
                      {" "}
                      Specific to this class:
                    </label>
                    <div>{obstacle}</div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-bold">
                      {" "}
                      What I would include if I wrote your own recommendation:
                    </label>
                    <div>{recommendation}</div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            "No Letter"
          )}
        </div>
      </div>
    </div>
  );
}
